import React from 'react';
import {
  Select, Input,
} from 'antd';
//import TextArea from 'antd/lib/input/TextArea';
import FormModal from '../../../../common/FormModal';

const { Option } = Select;
const UserFormModal = ({ ...props }) => (

  <FormModal
    {...props}
    // otherComponents={<div>{props.data.media === 'photo' ? <img width="250px" height="250px" alt="asset" src={props.data.url} /> : null}</div>}
    formItems={[
      {
        key: 'product_name',
        label: 'Product Name',
        rules: [{ required: true, message: "Please input User's name!" }],
        Component: <Input disabled />,
        hidden: true
      },
      {
        key: 'status',
        label: 'Status',
        rules: [{ required: true, message: "Please Select Asset's Approval Status!" }],
        Component: (
          <Select>
            <Option value>Approved</Option>
            <Option value={false}>Pending</Option>
          </Select>
        ),
      },
    ]}
  />
);
export default UserFormModal;
